(() => {
  const changeHomeSlide = (index) => {
    const slideshow = document.querySelector(".slideshow__contents-wrapper");
    const swiper = slideshow?.swiper;
    if (!swiper) return;
    if (typeof swiper.slideToLoop === "function") swiper.slideToLoop(index);
    else swiper.slideTo(index);
  };

  document.addEventListener(
    "pointerenter",
    (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest("[data-site-slideshow-index]");
      if (!link || event.pointerType === "touch") return;
      changeHomeSlide(Number(link.dataset.siteSlideshowIndex));
    },
    true
  );

  document.addEventListener(
    "focusin",
    (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest("[data-site-slideshow-index]");
      if (link) changeHomeSlide(Number(link.dataset.siteSlideshowIndex));
    },
    true
  );
})();


/* Madrid 1.7 places a full-card product link above parts of the card UI.
 * Keep Quick View precise and usable even if that overlay becomes the pointer
 * target: detect the real button rectangle, mirror its hover animation, and
 * forward only clicks that land inside that visible rectangle. */
(() => {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  let activeCard = null;
  let pendingPointer = null;
  let animationFrame = null;

  const clearActiveCard = () => {
    activeCard?.classList.remove("is-site-quickview-hover");
    activeCard = null;
  };

  const quickViewAtPoint = (card, clientX, clientY) => {
    if (!card) return null;
    const button = card.querySelector(
      ".card-quickview-inline button.card__link"
    );
    const wrapper = button?.closest(".card-quickview-inline");
    if (!button || !wrapper) return null;

    const wrapperStyle = window.getComputedStyle(wrapper);
    if (
      wrapperStyle.display === "none" ||
      wrapperStyle.visibility !== "visible" ||
      Number(wrapperStyle.opacity) === 0
    ) {
      return null;
    }

    const rect = button.getBoundingClientRect();
    return clientX >= rect.left &&
      clientX <= rect.right &&
      clientY >= rect.top &&
      clientY <= rect.bottom
      ? button
      : null;
  };

  const updateQuickViewHover = () => {
    animationFrame = null;
    const event = pendingPointer;
    pendingPointer = null;
    if (!event) return;

    const card =
      event.target instanceof Element
        ? event.target.closest(".card-wrapper")
        : null;
    const button = quickViewAtPoint(card, event.clientX, event.clientY);

    if (!button) {
      clearActiveCard();
      return;
    }

    if (activeCard !== card) {
      clearActiveCard();
      activeCard = card;
      activeCard.classList.add("is-site-quickview-hover");
    }
  };

  document.addEventListener(
    "pointermove",
    (event) => {
      if (event.pointerType === "touch") return;
      pendingPointer = event;
      if (animationFrame === null) {
        animationFrame = window.requestAnimationFrame(updateQuickViewHover);
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    "click",
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest(".card-quickview-inline")) return;

      const card = event.target.closest(".card-wrapper");
      if (!card) return;

      const button = quickViewAtPoint(card, event.clientX, event.clientY);
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      button.click();
    },
    true
  );

  document.addEventListener("pointerleave", clearActiveCard, true);
  window.addEventListener("blur", clearActiveCard);
  window.addEventListener("scroll", clearActiveCard, { passive: true });
})();

/* Keep Shopify's consent action compact without hiding its accessible name. */
(() => {
  const labels = {
    ar: "تخصيص",
    cs: "Upravit",
    de: "Anpassen",
    el: "Προσαρμογή",
    en: "Preferences",
    es: "Personalizar",
    fr: "Personnaliser",
    hu: "Testreszabás",
    it: "Personalizza",
    pl: "Dostosuj",
    sk: "Upraviť",
  };

  const updateConsentLabel = () => {
    const button = document.getElementById("shopify-pc__banner__btn-manage-prefs");
    if (!button) return false;
    const language = (document.documentElement.lang || "en").toLowerCase().split("-")[0];
    const label = labels[language] || labels.en;
    if (button.textContent?.trim() !== label) button.textContent = label;
    button.setAttribute("aria-label", label);
    return true;
  };

  if (updateConsentLabel()) return;

  /* Shopify injects the privacy banner asynchronously. A document-wide
   * MutationObserver used to run after every storefront DOM change until that
   * happened. A short, bounded schedule keeps the localized label reliable
   * without putting unrelated sliders, drawers and product cards on the hot
   * path. */
  const retryDelays = [250, 750, 1500, 3000, 6000, 10000];
  let consentLabelReady = false;

  retryDelays.forEach((delay) => {
    window.setTimeout(() => {
      if (consentLabelReady) return;
      consentLabelReady = updateConsentLabel();
    }, delay);
  });

  window.addEventListener(
    "load",
    () => {
      if (!consentLabelReady) consentLabelReady = updateConsentLabel();
    },
    { once: true }
  );
})();

/* Close mobile drawers in the same direction they entered. Keep the gesture
 * deliberately strict so vertical scrolling and product sliders retain their
 * native touch behaviour. */
(() => {
  const mobileViewport = window.matchMedia("(max-width: 749px)");

  const minimumDistance = 72;
  const horizontalRatio = 1.35;
  let gesture = null;

  const blockedTarget = (target) =>
    target.closest(
      ".swiper, [data-no-drawer-swipe], input, textarea, select, [contenteditable='true']"
    );

  document.addEventListener(
    "pointerdown",
    (event) => {
      gesture = null;
      if (!mobileViewport.matches) return;
      if (event.pointerType !== "touch" || !event.isPrimary || !(event.target instanceof Element)) return;
      if (blockedTarget(event.target)) return;

      const cart = event.target.closest("cart-drawer.active .drawer__inner");
      const menuPanel = event.target.closest(
        "header-drawer details[open].menu-opening .menu-drawer__inner-container"
      );
      if (!cart && !menuPanel) return;

      gesture = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        type: cart ? "cart" : "menu",
        owner: cart ? event.target.closest("cart-drawer") : event.target.closest("header-drawer"),
      };
    },
    { passive: true }
  );

  document.addEventListener(
    "pointerup",
    (event) => {
      if (!gesture || event.pointerId !== gesture.pointerId) return;

      const current = gesture;
      gesture = null;
      const deltaX = event.clientX - current.startX;
      const deltaY = event.clientY - current.startY;
      const horizontal = Math.abs(deltaX) >= Math.abs(deltaY) * horizontalRatio;
      if (!horizontal || Math.abs(deltaX) < minimumDistance) return;

      if (current.type === "cart" && deltaX > 0 && typeof current.owner?.close === "function") {
        current.owner.close();
      }
      if (
        current.type === "menu" &&
        deltaX < 0 &&
        typeof current.owner?.closeMenuDrawer === "function"
      ) {
        current.owner.closeMenuDrawer(event);
      }
    },
    { passive: true }
  );

  document.addEventListener("pointercancel", () => {
    gesture = null;
  });
})();
